import { memo } from 'react';

import MarketingCampaignActivityContent from '../../shared/MarketingCampaignActivityContent';

import './styles.scss';

const MarketingCampaignCardContent = memo(({ campaign, useIndividualMetrics }) => {
    return (
        <MarketingCampaignActivityContent
            campaign={campaign}
            variant="card"
            useIndividualMetrics={useIndividualMetrics}
        />
    );
});

MarketingCampaignCardContent.displayName = 'MarketingCampaignCardContent';

export default MarketingCampaignCardContent;
